import { sysGetMetadataField } from '@platform/layouts/system/metadata_field/helpers/sys_get_metadata_field';
import { sysGetMetadata } from '@platform/layouts/system/metadata/helpers/sys_get_metadata';
import { normalize } from '@platform/shared/helpers/formatters';

export async function statusAndColumnSetting(sysDocStateSettingList: any) {
    // Для настройка колонок и статусов будет использоваться два раздела
    // statuses - переходы по статусам (в завимости от статуса может быть тоже настройки колонок)
    // columns - колонки - редактирование, скрытие, расшаривание
    const sysDocStateSetting: any = {
        statuses: [],
        columns: [],
        sys_crud_function_settings: [],
    };

    if (Array.isArray(sysDocStateSettingList) && sysDocStateSettingList?.length) {
        // Для того чтобы вытаскивать схему таболицы для колонок и статусов
        // делаем запрос в sysMetadataFieldLis, а оттуда вытаскиваем sysMetadataList
        const sysMetadataList = await sysGetMetadata({});
        const sysMetadataFieldList = await sysGetMetadataField({ sys_metadata_id: null });

        sysDocStateSettingList.forEach((s) => {
            // region Cтатусы
            // sys_doc_state_in - приходт как json (В какой статус можно перейти)
            if (!sysDocStateSetting.statuses?.[`${s.table_schema}.${s.table_name}`]) {
                sysDocStateSetting.statuses[`${s.table_schema}.${s.table_name}`] = {};
            }

            if (!sysDocStateSetting?.statuses?.[`${s.table_schema}.${s.table_name}`]?.[s.sys_doc_state_from]) {
                sysDocStateSetting.statuses[`${s.table_schema}.${s.table_name}`][s.sys_doc_state_from] = [];
            }

            if (s?.sys_doc_state_in?.length) {
                s.sys_doc_state_in.forEach((sys: string) => {
                    sysDocStateSetting.statuses[`${s.table_schema}.${s.table_name}`][s.sys_doc_state_from].push(sys);
                });
            }
            //endregion

            columnSetting(sysDocStateSetting, s, s.table_schema, s.table_name, sysMetadataList, sysMetadataFieldList);

            sysCrudFunctionSetting(sysDocStateSetting, s);
        });
    }

    return sysDocStateSetting;
}

export function columnSetting(
    sysDocStateSetting: any,
    sysDocState: any,
    table_schema: any,
    table_name: any,
    sysMetadataList: any[],
    sysMetadataFieldList?: any[]
) {
    // region колонки
    // sys_metadata_field_setting - приходит как json
    // настройка колонок
    if (sysDocState?.sys_metadata_field_setting?.length && typeof sysDocState.sys_metadata_field_setting === 'string') {
        sysDocState.sys_metadata_field_setting = JSON.parse(sysDocState.sys_metadata_field_setting);
    }

    if (!sysDocStateSetting.columns?.[`${table_schema}.${table_name}`]) {
        sysDocStateSetting.columns[`${table_schema}.${table_name}`] = {};
    }

    if (sysDocState?.sys_metadata_field_setting?.length) {
        const sys_doc_state_from = sysDocState?.sys_doc_state_from;
        if (sys_doc_state_from) {
            // statuses
            if (!sysDocStateSetting.columns[`${table_schema}.${table_name}`]?.['statuses'])
                sysDocStateSetting.columns[`${table_schema}.${table_name}`]['statuses'] = {};

            sysDocStateSetting.columns[`${table_schema}.${table_name}`]['statuses'][`${sys_doc_state_from}`] = {};
        }

        sysDocState.sys_metadata_field_setting.forEach((sys: any) => {
            // Необходимо вытащить sysMetadataField так как
            // metadata_id может быть спецификация parent_id
            const sysMetadataField = sysMetadataFieldList?.find?.((sf: any) => sf?.id === sys?.sys_metadata_field_id);

            let sysMetadataParent;
            if (normalize(sysMetadataField?.sys_metadata_id) !== sysDocState.sys_metadata_id) {
                sysMetadataParent = sysMetadataList?.find?.(
                    (sf: any) => sf?.id === normalize(sysMetadataField?.sys_metadata_id)
                );
            }

            if (sysMetadataField) {
                const columnSetting = {
                    name: sysMetadataField.name,
                    is_hide: typeof sys.is_hide === 'boolean' ? sys.is_hide : undefined,
                    is_editable: typeof sys.is_editable === 'boolean' ? sys.is_editable : undefined,
                };

                if (sysMetadataParent) {
                    if (sys_doc_state_from) {
                        if (
                            !sysDocStateSetting.columns[`${table_schema}.${table_name}`]?.['statuses']?.[
                                `${sys_doc_state_from}`
                            ]?.[`${sysMetadataParent.table_schema}.${sysMetadataParent.table_name}`]
                        ) {
                            sysDocStateSetting.columns[`${table_schema}.${table_name}`]['statuses'][
                                `${sys_doc_state_from}`
                            ][`${sysMetadataParent.table_schema}.${sysMetadataParent.table_name}`] = [];
                        }

                        sysDocStateSetting.columns[`${table_schema}.${table_name}`]['statuses'][
                            `${sys_doc_state_from}`
                        ][`${sysMetadataParent.table_schema}.${sysMetadataParent.table_name}`][sysMetadataField.name] =
                            columnSetting;
                    } else {
                        if (
                            !sysDocStateSetting.columns[`${table_schema}.${table_name}`]?.[
                                `${sysMetadataParent.table_schema}.${sysMetadataParent.table_name}`
                            ]
                        ) {
                            sysDocStateSetting.columns[`${table_schema}.${table_name}`][
                                `${sysMetadataParent.table_schema}.${sysMetadataParent.table_name}`
                            ] = [];
                        }

                        sysDocStateSetting.columns[`${table_schema}.${table_name}`][
                            `${sysMetadataParent.table_schema}.${sysMetadataParent.table_name}`
                        ][sysMetadataField.name] = columnSetting;
                    }
                } else {
                    if (sys_doc_state_from)
                        sysDocStateSetting.columns[`${table_schema}.${table_name}`]['statuses'][sys_doc_state_from][
                            sysMetadataField.name
                        ] = columnSetting;
                    else
                        sysDocStateSetting.columns[`${table_schema}.${table_name}`][sysMetadataField.name] =
                            columnSetting;
                }
            }
        });
    }

    // endregion
}

export function sysCrudFunctionSetting(sysDocStateSetting: any, sysDocState: any) {
    const table_schema = sysDocState.table_schema;
    const table_name = sysDocState.table_name;

    // console.log(sysDocState, 'sysDocState');

    sysDocState.sys_crud_function_setting = JSON.parse(sysDocState?.sys_crud_function_setting ?? null);
    if (!sysDocState.sys_crud_function_setting) return;

    if (sysDocStateSetting.sys_crud_function_settings?.[`${table_schema}.${table_name}`]) {
        sysDocStateSetting.sys_crud_function_settings[`${table_schema}.${table_name}`] = {};
    }

    sysDocStateSetting.sys_crud_function_settings[`${table_schema}.${table_name}`] =
        sysDocState.sys_crud_function_setting;
}
